import React from "react";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import Checkbox from "Components/checkbox/Checkbox";
import TranslatedString from "Components/TranslatedString";

import t from "Utils/translation";
import cx from "classnames";
import s from "./notificationsCustomers.scss";

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.editCallbackUrl = this.editCallbackUrl.bind(this);
    this.editNotificationEmail = this.editNotificationEmail.bind(this);

    this.editCallbackUrl = this.editCallbackUrl.bind(this);
    this.editNotificationEmail = this.editNotificationEmail.bind(this);

    this.state = {
      viewFields: [
        "email_overquota_email",
        "notification_email",
        "domain_create_callback",
        "email_overquota_callback",
        "notification_url",
      ],
    };
  }

  editCallbackUrl(val) {
    let resettedFields = {};
    if (!val.notification_url) {
      resettedFields["domain_create_callback"] = false;
      resettedFields["email_overquota_callback"] = false;
    }
    this.props.setFormFieldValue({ ...val, ...resettedFields });
  }

  editNotificationEmail(val) {
    let resettedFields = {};
    if (!val.notification_url) {
      resettedFields["email_overquota_email"] = false;
    }
    this.props.setFormFieldValue({ ...val, ...resettedFields });
  }

  editCallbackUrl(val) {
    let resettedFields = {};
    if (!val.notification_url) {
      resettedFields["domain_create_callback"] = false;
      resettedFields["email_overquota_callback"] = false;
    }
    this.props.setFormFieldValue({ ...val, ...resettedFields });
  }

  editNotificationEmail(val) {
    let resettedFields = {};
    if (!val.notification_url) {
      resettedFields["email_overquota_email"] = false;
    }
    this.props.setFormFieldValue({ ...val, ...resettedFields });
  }

  // validate(data, validator) {
  //   let errors = {}
  //   if ((data.domain_create_callback || data.email_overquota_callback) && !data.notification_url) {
  //     errors['notification_url'] = 'Callback url is missing'
  //   }

  //   const opts = { protocols: ['https'], require_protocol: true }
  //   if (data.notification_url && !validator.isURL(data.notification_url, opts)) {
  //     errors['notification_url'] = 'Callback url is not a valid https URL'
  //   }

  //   if (data.email_overquota_email && data.notification_email.length <= 0) {
  //     errors['notification_url'] = 'Email is missing'
  //   }

  //   if (data.notification_email && !validator.isEmail(data.notification_email)) {
  //     errors['notification_email'] = 'Email is not a valid email address'
  //   }
  //   return errors
  // }

  render() {
    const { formData, isFormLoading, submitForm, setFormFieldValue, formErrors } = this.props;

    const isOneCallbackActionSelected = !!formData.email_overquota_callback || !!formData.domain_create_callback;
    const isOneEmailActionSelected = !!formData.email_overquota_email;
    return (
      <form className={s.notifications} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.infoBtnGroup}>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.webhook.title")}</div>
              <div className="sectionDesc">{t("settings.sections.webhook.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                label={t("input.label.callbackURL")}
                placeholder={t("input.placeholder.url_callback")}
                name="notification_url"
                onChange={this.editCallbackUrl}
                required={isOneCallbackActionSelected}
                value={formData.notification_url}
                errors={formErrors.notification_url}
              />

              <Checkbox
                className="inputFull2"
                label={t("input.label.quotaExceeded")}
                name="email_overquota_callback"
                checked={formData.email_overquota_callback}
                onChange={setFormFieldValue}
                disabled={!formData.notification_url || formData.notification_url.length == 0}
              />

              <Checkbox
                className="inputFull2"
                label={t("input.label.domain.creationNotification")}
                name="domain_create_callback"
                checked={formData.domain_create_callback}
                onChange={setFormFieldValue}
                disabled={!formData.notification_url || formData.notification_url.length == 0}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.emailNotifications.title")}</div>
              <div className="sectionDesc">{t("settings.sections.emailNotifications.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                label={t("input.label.email.notification")}
                placeholder={t("input.placeholder.email")}
                name="notification_email"
                value={formData.notification_email}
                required={isOneEmailActionSelected}
                placeholder="alert@yoursite.com"
                onChange={this.editNotificationEmail}
              />

              <Checkbox
                className="inputFull2"
                label={t("input.label.quotaExceeded")}
                name="email_overquota_email"
                checked={formData.email_overquota_email}
                onChange={setFormFieldValue}
                disabled={!formData.notification_email || formData.notification_email.length == 0}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
